import React from 'react';

const LearningPageNavigation = ({ 
  currentMicroIndex, 
  totalMicroChunks, 
  goToPreviousMicroChunk, 
  goToNextMicroChunk 
}) => {
  const isFirstPoint = currentMicroIndex === 0;
  const isLastPoint  = currentMicroIndex === totalMicroChunks - 1;

  const baseStyle = {
    position        : 'fixed',
    top             : '50%',
    transform       : 'translateY(-50%)',
    zIndex          : 200,
    width           : '44px',
    height          : '80px',
    display         : 'flex',
    alignItems      : 'center',
    justifyContent  : 'center',
    fontSize        : '36px',
    fontWeight      : '700',
    color           : 'white',
    border          : 'none',
    cursor          : 'pointer',
    transition      : 'all 0.2s ease',
    boxShadow       : '0 4px 12px rgba(0,0,0,0.3)',
    lineHeight      : '1',
    userSelect      : 'none',
  };

  return (
    <>
      {/* ── Previous ───────────────────────────────────────────────────── */}
      <button
        onClick={goToPreviousMicroChunk}
        disabled={isFirstPoint}
        title="Previous Point"
        style={{
          ...baseStyle,
          left            : '0',
          borderRadius    : '0 40px 40px 0',
          background      : isFirstPoint
            ? 'rgba(180,180,180,0.35)'
            : 'rgba(102, 126, 234, 0.85)',
          cursor          : isFirstPoint ? 'not-allowed' : 'pointer',
        }}
      >
        ‹
      </button>

      {/* ── Next / Complete ─────────────────────────────────────────────── */}
      <button
        onClick={goToNextMicroChunk}
        title={isLastPoint ? 'Mark Complete' : 'Next Point'}
        style={{
          ...baseStyle,
          right           : '0',
          borderRadius    : '40px 0 0 40px',
          background      : isLastPoint
            ? 'rgba(16, 185, 129, 0.85)'
            : 'rgba(102, 126, 234, 0.85)',
        }}
      >
        {isLastPoint ? '✓' : '›'}
      </button>
    </>
  );
};

export default LearningPageNavigation;